import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import AuthGate from './components/auth/AuthGate';
import { RouterProvider } from 'react-router-dom';
import { store } from './store';
import { router } from './routes';
import './index.css';

createRoot(document.getElementById('root')).render(
  <Provider store={store}>
    <AuthGate>
      <RouterProvider router={router} />
    </AuthGate>
  </Provider>,
);
